import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  WOW,
  Optimum,
  Mediacom,
} from 'config/providers';
import { SpectrumTheme } from 'config/themes';
import { spectrumRedirectUrl } from 'config/redirectUrls';

// Origin - https://updater.atlassian.net/browse/COREX-951
export const LLMSpectrumPartner: SingleProviderConfig = {
  name: 'LLMSpectrumPartner',
  micrositeCode: 'LLMSpectrumAd',
  mainProvider: Spectrum,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'spectrumspecial.com',
  homepage: 'https://spectrumspecial.com',
  title: 'Spectrum Authorized Dealer',
  fallbackPhoneNumber: '855-556-4063',
  fallbackLeadModePhoneNumber: '855-556-4062',
  defaultCheckoutType: CheckoutType.PROVIDER_REDIRECT,
  defaultTheme: SpectrumTheme,
  needsDcSession: false,
  source: 'Spectrum',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [Comcast, Cox, Optimum, Mediacom, WOW],
  updaterCrossSellActive: false,
  getProviderRedirectUrl: spectrumRedirectUrl,
};
